<template>
  <section>
    <div class="box">
      <div class="box-content">
        <!-- form -->
        <validation-observer ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(editAutomation)">
            <div class="margin-top-l">
              <validation-provider
                name="nome"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field item group-input "
                  :class="{ errors: errors[0] }"
                >
                  Nome da Automação
                  <input
                    type="text"
                    v-model="newAutomation.name"
                    placeholder="Nome da campanha"
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <!-- type -->
              <div class="flex column">
                <div class="flex-1 p-8">
                  Tipo de Automação
                </div>
                <div class="flex-1" style="padding: 8px">
                  <div
                    class="button secondary"
                    :class="{ 
                      active: newAutomation.auto_type === 'EMAIL',
                      disabled: newAutomation.auto_type !== 'EMAIL'
                    }"
                  >
                    E-MAIL
                  </div>
                  <div
                    class="button secondary"
                    :class="{ 
                      active: newAutomation.auto_type == 'WHATSAPP',
                      disabled: newAutomation.auto_type !== 'WHATSAPP',
                    }"
                    style="margin-left: 8px"
                  >
                    WHATSAPP
                  </div>
                  <div
                    class="button secondary"
                    :class="{ 
                      active: newAutomation.auto_type === 'SMS',
                      disabled: newAutomation.auto_type !== 'SMS',
                    }"
                    style="margin-left: 8px"
                  >
                    SMS
                  </div>
                </div>
              </div>

              <!-- contacts -->
              <div>
                <div class="flex p-8 margin-top-m column">
                  Gatilho de ativação:
                  <div class="margin-top-s">
                    <p>
                      Quando o contato entrar em uma lista ou for adicionado uma
                      tag a automação vai começar para ele.
                    </p>
                  </div>
                </div>
                <div class="flex margin-top-l">
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Lista
                      <select
                        class="input"
                        v-model="newAutomation.contact_list_id"
                      >
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in listsAccount"
                          :key="k"
                          :value="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Tag
                      <select
                        class="input"
                        v-model="newAutomation.contact_tag_id"
                      >
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in tagsAccount"
                          :key="k"
                          :value="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Exclusão de Tag
                      <select class="input" v-model="newAutomation.not_contact_tag_id">
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in tagsAccount"
                          :key="k"
                          :value="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="flex margin-top-l">
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Tempo em minutos que o contato foi inserido na <b>Lista</b> Ou <b>Tag</b> para ativar a automação.
                      <input type="number" v-model="newAutomation.time_to_active"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- message -->
            <div v-if="automation_id" class="flex column margin-top-l p-8">
              Fluxo de mensagens: (Adicione cada mensagem individualmente no
              fluxo):
              <div class="margin-top-s box-messages w100">
                <ul>
                  <li v-if="notHaveMessage">
                    <small>
                      Adicione sua primeira mensagem para começar a rodar sua
                      automação.
                    </small>
                  </li>
                  <li v-for="(m, k) in newAutomation.messages" :key="k">
                    <div class="flex middle">
                      <div class="flex-2 flex middle">
                        <div class="flex column order">
                          <div class="button secondary" @click="upOrder(m)"><i class="fas fa-chevron-up"></i></div>
                          <div class="button secondary margin-top-s" @click="downOrder(m)"><i class="fas fa-chevron-down"></i></div>
                        </div>
                        <div style="margin-left: 16px">
                          <div v-if="m.message_type !== 'AWAIT'">
                            ({{ m.order | number }}) {{ m.name }} <span class="tag">{{ m.message_type }}</span>
                          </div>
                          <div v-else>
                            ({{ m.order | number }}) {{ m.description }} <span class="tag">{{ m.message_type }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="flex-1 flex end">
                        <div
                          class="button secondary"
                          @click="showModalEditMessage(m)"
                        >
                          <i class="fas fa-edit"></i>
                        </div>
                        <div
                          class="button secondary"
                          @click="openModalDuplicate(m.id)"
                        >
                          <i class="fas fa-copy"></i>
                        </div>
                        <div
                          class="button secondary"
                          @click="showDeleteMessage(m.id)"
                        >
                          <i class="fas fa-trash"></i>
                        </div>
                      </div>
                    </div>
                  </li>
                  <div class="actions margin-top-l">
                    <div
                      class="button secondary"
                      @click="showModalNewMessage()"
                    >
                      Adicionar nova mensagem
                    </div>
                  </div>
                </ul>
              </div>
            </div>

            <div class="margin-top-l actions">
              <router-link :to="{ name: 'Automation' }">
                <button class="button secondary">
                  Voltar
                </button>
              </router-link>

              <button class="button primary" type="submit">
                Salvar Automação
              </button>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>

    <!-- modals -->
    <!-- new message -->
    <modal-new-message
      :show="showModalEdit"
      :message="newMessage"
      :automation="newAutomation"
      @close="
        showModalEdit = false;
        newMessage = null;
      "
      @accept="newOrEditMessage($event)"
    ></modal-new-message>
    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar essa mensagem?"
      @cancel="
        showModalDelete = false;
        selectModalDelete = null;
      "
      @accept="deleteMessage(selectModalDelete)"
    ></modal-confirm>

    <!-- modal confirm duplicate -->
    <modal-confirm
      :show="showModalDuplicate"
      description="Você tem certeza que deseja duplicar essa mensagem?"
      @cancel="
        showModalDuplicate = false;
        duplicateMsg = null;
      "
      @accept="duplicateMessage(duplicateMsg)"
    ></modal-confirm>
  </section>
</template>

<script>
import { getContacts } from "@/services/contact";

import { updateAutomation, getAutomation } from "@/services/automation";

import {
  createMessageAut,
  updateMessageAut,
  // getMessagesAut,
  duplicateMessageAut,
  removeMessageAut,
} from "@/services/message";

import { getTags } from "@/services/tag";

import { getLists } from "@/services/list";

import ModalConfirm from "@/components/modal/ModalConfirm";
import ModalNewMessage from "./NewMessage";

const emptyMessage = {
  name: "",
  description: "",
  order: 1,
  message_type: "TEXT",
};

export default {
  name: "automation-edit",
  components: {
    ModalConfirm,
    ModalNewMessage,
  },
  props: ["automation_id"],
  data() {
    return {
      newAutomation: {
        name: "",
        auto_type: "",
        template: "DEFAULT",
        contact_list_id: "",
        contact_tag_id: "",
        not_contact_tag_id: "",
        time_to_active: 60,
        status: "",
        messages: [],
      },
      listsAccount: [],
      tagsAccount: [],
      totalContacts: null,
      //
      selectModalDelete: null,
      showModalDelete: false,
      //
      showModalEdit: false,
      newMessage: null,
      //
      showModalDuplicate: false,
      duplicateMsg: null,
    };
  },
  mounted() {
    this.getTags();
    this.getLists();

    if (this.automation_id) {
      this.getAutomation();
    }
  },
  watch: {
    "newAutomation.contact_list_id"() {
      this.getContacts();
    },
    "newAutomation.contact_tag_id"() {
      this.getContacts();
    },
  },
  computed: {
    formatTotalContacts() {
      if (this.totalContacts === null) {
        return " --- ";
      }

      return this.totalContacts;
    },
    notHaveMessage() {
      return (
        this.newAutomation &&
        this.newAutomation.messages &&
        this.newAutomation.messages.length == 0
      );
    },
  },
  methods: {
    upOrder(msg) {
      msg.order = msg.order - 2
      this.recalculateOrders(msg)
    },
    downOrder(msg) {
      msg.order = msg.order + 2
      this.recalculateOrders(msg)
    },
    recalculateOrders() {
      this.newAutomation.messages.sort((a, b) => a.order - b.order);

      let currentOrder = 1;
      this.newAutomation.messages.forEach((message) => {
        message.order = currentOrder++;
      });

      // Optionally update the messages on the server side after recalculating
      this.newAutomation.messages.forEach((message) => {
        this.updateMessage(message);
      });
    },
    openModalDuplicate(msgId) {
      this.showModalDuplicate = true
      this.duplicateMsg = msgId
    },
    newOrEditMessage(newMessage) {
      this.showModalEdit = false;
      this.newMessage = null;
      if (newMessage.id) {
        return this.updateMessage(newMessage);
      }

      return this.createMessage(newMessage);
    },
    showModalNewMessage() {
      this.newMessage = Object.assign({}, emptyMessage);
      this.showModalEdit = true;
    },
    showModalEditMessage(message) {
      this.newMessage = message;
      this.showModalEdit = true;
    },
    showDeleteMessage(message_id) {
      this.selectModalDelete = message_id;
      this.showModalDelete = true;
    },
    duplicateMessage(message_id) {
      this.showModalDuplicate = false
      this.duplicateMsg = null
      duplicateMessageAut(this.automation_id, message_id) 
        .then((result) => {
          this.newAutomation.messages.push(result)
          this.$toast.success({
            title:'Sucesso',
            message:'Mensagem duplicada'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao duplicar mensagem'
          })
        })
    },
    deleteMessage(message_id) {
      console.log("message_id", message_id);

      removeMessageAut(this.automation_id, message_id)
        .then(() => {
          this.newAutomation.messages = this.newAutomation.messages.filter(
            (m) => m.id != message_id
          );
          this.$toast.success({
            title: "Sucesso",
            message: "Mensagem removida",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao remover mensagem",
          });
        })
        .finally(() => {
          this.selectModalDelete = null;
          this.showModalDelete = false;
        });
    },
    getAutomation() {
      getAutomation(this.automation_id)
        .then((result) => {
          this.newAutomation = result;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao buscar campanha",
          });
        });
    },
    editAutomation() {
      let params = this.newAutomation;

      updateAutomation(this.automation_id, params)
        .then(() => {
          // TODO: Redirect to details
          this.$toast.success({
            title: "Sucesso",
            message: "Campanha editada",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    updateMessage(newMessage) {
      console.log("newMessage", newMessage);
      updateMessageAut(this.automation_id, newMessage.id, newMessage)
        .then((result) => {
          // FIXME: Adicionar ordenação de mensagens
          // this.newAutomation.messages.push(result)
          console.log("result", result);

          this.$toast.success({
            title: "Sucesso",
            message: "Mensagem editada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao editar mensagem",
          });
        });
    },
    calCulateNewOrder() {
      const orders = this.newAutomation.messages.map(m => m.order);
      const maxOrder = Math.max(0, ...orders); 
      return maxOrder + 1;
    },
    
    createMessage(newMessage) {
      console.log("newMessage", newMessage);
      newMessage.order = this.calCulateNewOrder()
      createMessageAut(this.automation_id, newMessage)
        .then((result) => {
          // FIXME: Adicionar ordenação de mensagens
          this.newAutomation.messages.push(result);

          this.$toast.success({
            title: "Sucesso",
            message: "Mensagem criada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao criar mensagem",
          });
        });
    },
    getTags() {
      this.getTags = [];
      getTags()
        .then((result) => {
          this.tagsAccount = result.map((r) => {
            return { id: r.id, label: r.name };
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao buscar dados",
          });
        });
    },
    getLists() {
      getLists()
        .then((result) => {
          this.listsAccount = result.map((r) => {
            return { id: r.id, label: r.name };
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao buscar dados",
          });
        });
    },
    getContacts() {
      let params = {
        page: 1,
        offset: 1,
        tag: this.newAutomation.contact_tag_id,
        list: this.newAutomation.contact_list_id,
      };
      getContacts(params)
        .then((result) => {
          this.totalContacts = result.total;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar total de contatos",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.contacts {
  padding-left: 8px;
}
.p-8 {
  padding: 0px 8px;
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 1030px;
  min-width: 1030px;
  min-height: 200px;
  max-height: 200px;
}

.active {
  background: var(--primary) !important;
  color: #fff !important;
}

.disabled {
  background: #c2c2c2 !important;
  color: #000 !important;
  border: 0px !important;
  cursor: auto !important;
}

.actions {
  padding: 0px 8px;
  * {
    margin-right: 8px;
  }
}
.box-messages {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 16px 8px;
  ul {
    list-style: none;
    li {
      padding: 8px 16px;
      border-bottom: 1px solid #ccc;
      .tag {
        background: #c2c2c2;
        padding: 4px 6px;
        border-radius: 5px;
        font-size: 11px;
        font-weight: 800;
        margin-left: 8px;
      }
      .button {
        margin-left: 4px;
      }
    }
  }
}
</style>

<style lang="scss">
.mx-datepicker {
  .mx-input-wrapper {
    .mx-input {
      height: 50px;
    }
  }
  // fix icon
  svg {
    margin-top: 10px;
  }
}
</style>
